import React from 'react';
import { ClipboardListIcon, PrinterIcon, UsersIcon, ListOrderedIcon, LayersIcon, FileDownIcon } from 'lucide-react';
const coverage = [{
  label: 'What you get',
  body: 'The day’s practice, already written — not a drill to look up',
  Icon: ClipboardListIcon
}, {
  label: 'Every week',
  body: 'Open the volume, print today’s sheet, run it as-is',
  Icon: PrinterIcon
}, {
  label: 'No dead time',
  body: 'Stations so no kid is standing around waiting',
  Icon: UsersIcon
}, {
  label: 'Right order',
  body: 'Skills sequenced across the season, not random drills',
  Icon: ListOrderedIcon
}, {
  label: 'Any age',
  body: 'Scaled for 5-6 through 13+ with the Age Cheat Sheet',
  Icon: LayersIcon
}, {
  label: 'Printable',
  body: 'Timed practice sheets built to print and clip to a board',
  Icon: FileDownIcon
}];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="w-full border-y-4 border-gold bg-navy-mid" data-id="element-202" data-mp="1pnjlmpxh6dua">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-203" data-mp="1f2j6qz6wh9qv">
        <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-204" data-mp="1f0q0hl078rje">
          The mechanism
        </p>
        <h2 id="mechanism-heading" className="chalk-underline mt-3 font-display font-bold uppercase text-white text-3xl sm:text-5xl" data-id="element-205" data-mp="1jvlswm9clgx1">
          The Print-and-Coach System
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base sm:text-lg text-white/75" data-id="element-206" data-mp="w3eznvyx5q1u">
          The whole season comes planned, sequenced and timed. It’s not a stack
          of loose drills you have to assemble &mdash; it’s “what to do on
          Tuesday.” You open the volume, print the sheet for today, and run it.
        </p>

        <ul className="mt-8 grid gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-207" data-mp="2cgve5g8wo96b">
          {coverage.map(({
          label,
          body,
          Icon
        }) => <li key={label} className="flex items-start gap-3 rounded-lg border border-navy-line bg-white/5 px-4 py-3.5" data-id="element-208" data-mp="2hj49ukd5xpc4">
              <span className="mt-0.5 flex h-8 w-8 flex-none items-center justify-center rounded-md bg-ice-dark/15 text-gold" data-id="element-209" data-mp="1msregm72q8qq">
                <Icon className="h-4 w-4" aria-hidden="true" data-id="element-210" data-mp="21qa9u7e9bk75" />
              </span>
              <span data-id="element-211" data-mp="1wta11oq0w3cc">
                <span className="block text-[11px] font-bold uppercase tracking-widest text-gold" data-id="element-212" data-mp="1wpw08kx0c270">
                  {label}
                </span>
                <span className="mt-1 block text-sm text-white/85" data-id="element-213" data-mp="1442uc2gf07g0">{body}</span>
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}